import { TextField } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import React, { SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ETheme } from '../../../../shared/enums/user/ETheme';
import { IEmployeeSkills } from '../../../../shared/interfaces/employeeSkills/IEmployeeSkills';
import { IUser } from '../../../../shared/interfaces/user/IUser';
import { darkPalette, lightPalette } from '../../../../shared/mui/palettes';
import { RootState } from '../../../../store/store';

interface IProps {
  open: boolean;
  handleClose: () => void;
  handleSubmit: () => void;
  isUpdate?: boolean;
  selectedSkill: IEmployeeSkills;
  setSelectedSkill: React.Dispatch<SetStateAction<IEmployeeSkills | null>>;
}
const EmployeeSkillFormModal = ({
  open,
  handleClose,
  handleSubmit,
  selectedSkill,
  setSelectedSkill,
  isUpdate,
}: IProps) => {
  const { t } = useTranslation();
  const { theme } = useSelector(
    (state: RootState) => state?.auth?.userData,
  ) as IUser;
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        className={'MuiModalBody'}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: { xs: '80%', lg: '30%' },
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: '100%',
            mb: '30px',
            pb: '10px',
            borderBottom: `1px solid ${theme === ETheme.LIGHT ? lightPalette.primary.light : darkPalette.background.light}`,
          }}
        >
          <Typography id="modal-modal-title" variant="h6">
            {t(isUpdate ? 'employee.updateSkill' : 'employee.createSkill')}
          </Typography>
        </Box>
        <TextField
          value={selectedSkill?.name ?? ''}
          onChange={(e) => {
            setSelectedSkill(
              (prev) =>
                ({ ...prev, name: e?.target?.value }) as IEmployeeSkills,
            );
          }}
          label={t('general.name')}
          sx={{ width: '100%', paddingBottom: '20px' }}
        />
        <div>
          <Button
            variant={'contained'}
            color={'secondary'}
            size={'small'}
            onClick={handleClose}
            sx={{ marginRight: '10px' }}
          >
            {t('button.cancel')}
          </Button>
          <Button variant={'contained'} size={'small'} onClick={handleSubmit}>
            {t(isUpdate ? 'button.update' : 'button.create')}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default EmployeeSkillFormModal;
